//---------- TOUCH EVENTS --------------------------------------//
import '@benmajor/jquery-touch-events';
import 'jquery-clickout';
import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false,
            hideEmpty: true
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'widget_more';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.$html = $('html');
    	this.$btn = this.$el.find( '.btn' );
        this.$options = this.$el.find( '.options' );

    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$btn.on( 'tap', ()=>this.toggle() );
    			this.$el.on( 'clickout', ()=>this.open(false) );
    		}
    		else{
    			this.$btn.on( 'mouseenter', ()=>this.open(true) );
    			this.$el.on( 'mouseleave', ()=>this.open(false) );
    		}
            this.$options.find( 'a' ).on( 'click',  ()=>this.open(false) );
		}
		else{
    		if ( this.$html.hasClass( 'touch' ) ){
    			this.$btn.off( 'tap', ()=>this.toggle() );
    			this.$el.off( 'clickout', ()=>this.open(false) );
    		}
    		else{
    			this.$btn.off( 'mouseenter', ()=>this.open(true) );
    			this.$el.off( 'mouseleave', ()=>this.open(false) );
    		}
            this.$options.find( 'a' ).off( 'click',  ()=>this.open(false) );
		}
        
        this.initModeFilterSlug( b );
        this.initModeFilterUrl( b );
	}

    //---------------------------------------- METHODS ---------------------------------------//
    open(b){
        if ( this.$el.hasClass( 'open' ) === b ){
            return;
        }
    	if ( b ){
			this.$el.addClass( 'open' ); 		
    	}
    	else{
    		this.$el.removeClass( 'open' );
    	}
        gsap.fromTo( this.$options, {y:b?-10:0}, {y:b?0:-10, ease:'power3.easeIn', duration:0.6, delay:0 } );
    }

    toggle(){
    	this.open( ! this.$el.hasClass( 'open' ) );
    }

    initModeFilterSlug( b ){
        if ( this.$el.attr( 'data-mode' ) === 'slug' ){
            if ( b ){
                this.$el.find( '.menu a' ).on( 'click', (e)=>this.filter(e) );
                this.$el.find( 'select' ).on( 'change', (e)=>this.filterSelect(e) );

                if ( this.options.hideEmpty ){
                    this.hideEmpty()
                }

            }
            else{
                this.$el.find( '.menu a' ).off( 'click', (e)=>this.filter(e) );
                this.$el.find( 'select' ).off( 'change', (e)=>this.filterSelect(e) );
            }
        }
    }

    hideEmpty(){
        let $a, tax, slug, $target, $t, s, t, found;

        this.$el.find( '.menu a' ).each( (i,el) => {
            $a      = $(el);
            tax     = $a.attr( 'data-tax' );
            slug    = $a.attr( 'data-slug' );
            $target = $( '.' + this.$el.attr( 'data-target' ) );

            if ( $target.length > 0 ){

                found = false;

                $target.each( ( j, eel ) => {

                    $t      = $(eel);
                    s       = $t.attr( 'data-slug' );
                    t       = $t.attr( 'data-tax' );

                    if ( tax === t ){
                        if ( slug === s ){
                            found = true;
                        }
                    }
                });

                if ( !found ){
                    $a.parent('li').css({'display':'none'});
                    this.hideOption( tax, slug );
                }

            }

        });
    }

    hideOption( tax, slug ){
        let $o;
        this.$el.find( 'select option' ).each( (i,el)=>{
            $o = $(el);
            if ( $o.attr( 'data-slug' ) === slug && $o.attr('data-tax') === tax ){
                $o.remove()
            }
        })
    }

    filter(e){
        e.preventDefault();

        let $a      = $(e.currentTarget),
            tax     = $a.attr( 'data-tax' ),
            slug    = $a.attr( 'data-slug' ),
            $target = $( '.' + this.$el.attr( 'data-target' ) ),
            l       = $target.length,
            $t, s, t;

        if ( slug && tax  && $target.length > 0){


            $target.each( ( i, el ) => {

                $t      = $(el);
                s       = $t.attr( 'data-slug' );
                t       = $t.attr( 'data-tax' );

                if ( tax === t ){
                    if ( slug === 'all' ){
                        $t.css({
                            display: 'block'
                        })
                    }
                    else{
                        $t.css({
                            display: slug === s ? 'block' : 'none'
                        });
                    }
                }

            });

            this.revelSectionsHeader( );

            gsap.fromTo( $target, {opacity:0}, {opacity:1, duration:0.4, ease:'power.easeOut'} );
        }    
    }

    revelSectionsHeader( ){
        
        let $sections = $( '.' + this.$el.attr( 'data-target-section' ) ), $s, $target, hidden, total;
        if ( $sections.length > 0 ){
            $sections.each( (i, el )=>{
                $s = $(el);
                $target = $s.find( '.' + this.$el.attr( 'data-target' ) );
                total = $target.length;
                if ( total > 0 ){
                    hidden = 0;
                    $target.each( ( j, t) => {
                        if ( $(t).css( 'display' ) === 'none' ){
                            hidden++;
                        }
                    });

                    gsap.to( $s, {opacity:hidden<total?1:0, duration:0.4, ease:'power.easeOut'} );

                    if ( hidden < total ){
                        $s.slideDown(0)
                    }
                    else{
                        $s.slideUp(0)
                    }
                    
                }
            })
        }
    }

    filterSelect(e){
        let $a      = $(e.currentTarget);
        this.filter( {
            currentTarget: $a.find(":selected"),
            preventDefault: ()=>{return true}
        } );
    }


    //---------------------------- MODE URL -----------------------------------//    
    initModeFilterUrl( b ){
        if ( this.$el.attr( 'data-mode' ) === 'url' || this.$el.attr( 'data-mode' ) === 'news' ){
            if ( b ){
                //this.$el.find( '.menu a' ).on( 'click', (e)=>this.filterUrl(e) );
                this.$el.find( 'select' ).on( 'change', (e)=>this.filterUrl(e) );
            }
            else{
                //this.$el.find( '.menu a' ).off( 'click', (e)=>this.filterUrl(e) );
                this.$el.find( 'select' ).off( 'change', (e)=>this.filterUrl(e) );
            }
        }
    }
    filterUrl(e){
        let $a      = $(e.currentTarget), href;
        if ( $a.attr( 'href' ) ){
            e.preventDefault();
            href = $a.attr( 'data-href' );
        }
        else{

            if ( this.$el.attr( 'data-mode' ) === 'news' ){
                href = $a.val();
            }
            else{
                href = $a.find(":selected").attr( 'data-href' );
            }
        }
        if ( href && this.main ){
            this.main.barba_triggerURL( href, $a );
        }
    }

    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}


